import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_drag_timeline_head",
  "use": "icon-icon_drag_timeline_head-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 19 19\" id=\"icon-icon_drag_timeline_head\">\n<style type=\"text/css\">\n</style>\n<path class=\"st0\" d=\"M2.5,1h14v9L10,19H9l-6.5-9V1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol